import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	mobileButton: {
		width: '100%',
		justifyContent: 'space-between',
	},
	applyButton: {
		// some extra space for a dropdown needed
		marginTop: theme.spacing.large,
		width: '100%',
		justifyContent: 'center',
	},
	mobileButtonText: { display: 'inline-flex', width: '100%' },
}));
